module.exports = __webpack_public_path__ + "static/media/caret-down.120ef998.svg";